import { useCallback } from 'react';
import { Geolocation } from '@capacitor/geolocation';
import { Device } from '@capacitor/device';

/** 检查设备的定位权限，并处理授权逻辑 */
export const useCheckLocationPermission = () => {
  const checkLocationPermission = useCallback(() => {
    return new Promise(async (resolve, reject) => {
      try {
        const deviceInfo = await Device.getInfo();

        // 非安卓端直接校验通过
        if (deviceInfo?.platform !== 'android') {
          resolve('');
          return;
        }

        const geoPermission = await Geolocation.checkPermissions();
        console.log('当前的permission:', geoPermission);

        if (geoPermission.coarseLocation === 'granted' && geoPermission.location === 'granted') {
          resolve('');
        } else if (geoPermission.coarseLocation === 'denied' && geoPermission.location === 'denied') {
          reject('');
        } else {
          console.log('都是prompt，请求权限');
          const result = await Geolocation.requestPermissions({
            permissions: ['location', 'coarseLocation'],
          });
          console.log('获取权限的result', result);
          if (result.location === 'granted' && result.coarseLocation === 'granted') {
            resolve('');
          } else {
            reject('');
          }
        }
      } catch (e) {
        reject(e);
        console.error(e);
      }
    });
  }, []);

  return { checkLocationPermission };
};
